import { Injectable } from '@angular/core';
import { DialogService, DialogSettings } from '@progress/kendo-angular-dialog';
import { AboutDialogComponent } from '../components/about-dialog/about-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class AboutDialogService {
  constructor(private dialogService: DialogService) {}

  openAboutDialog() {
    const options: DialogSettings = {
      title: 'About',
      content: AboutDialogComponent,
      minWidth: 400
    };
    this.dialogService.open(options);
  }
}
